import {
    ActivitiesSearchPageDesktopActivitiesContextManifestV6,
    ActivitiesSearchPageDesktopActivitiesContextFieldsV6,
    ActivitiesSearchPageDesktopActivitiesContextIdsV6,
} from '@agoda/analytics-messages-definition-activities/manifest/activities-search-page-desktop';
import { PartialActivitiesWebAppDataContextFields, WebAnalyticsBinder, WebAnalyticsContextFieldsMap } from 'core/messaging/analytics/ActivitiesAppDataContext';
import { SearchPageContextFields } from 'core/messaging/analytics/pages/pageEventsMapping';
import { DefaultRequestProps } from 'store/api/ApiConstants';
import { getStoreState } from 'store/store';
import { getKeywordQueryParams } from 'gql/service/graph/activityService';
import { search as getLocationSearch } from 'core-framework/window/location';
import { getDateInYmdFormat } from 'core-framework/util/datetime/date';
import { determineSearchPageType } from 'core/utils/pageUtils';

const getSearchPageContextPropsFromState = () => {
    const { search: searchState, home: homeState } = getStoreState();
    const locationSearch = getLocationSearch();
    const keyword = getKeywordQueryParams(locationSearch);
    const result = searchState?.searchResponse?.result;
    const travelDate = getDateInYmdFormat(homeState?.searchBoxSettings?.travelDate);
    const searchType = determineSearchPageType();

    if (!result || !result.resultInfo || searchState.isLoading) {
        return {
            page_number: 1,
            action_element_value: '0',
            search_phrase: keyword,
            travel_date: travelDate,
            search_type: searchType,
        };
    }

    return {
        page_number: searchState.pageNumber,
        action_element_value: String(result.resultInfo.totalFilteredActivities || 0),
        search_phrase: keyword,
        travel_date: travelDate,
        search_type: searchType,
    };
};
export const getSearchPageContextFields = (): WebAnalyticsContextFieldsMap<PartialActivitiesWebAppDataContextFields & SearchPageContextFields> => {
    let props: ReturnType<typeof getSearchPageContextPropsFromState>;
    return {
        // These property accessors are called in sequence by virtue of Object.keys iterating in order.
        // We can fetch the required data in the first accessors and use it in the subsequent ones.
        bl_page_size: DefaultRequestProps.search.pagination.size,
        page_number: () => {
            props = getSearchPageContextPropsFromState();
            return props.page_number;
        },
        action_element_value: () => {
            return props.action_element_value;
        },
        search_phrase: () => {
            return props.search_phrase;
        },
        travel_date: () => {
            return props.travel_date;
        },
        search_type: () => {
            return props.search_type;
        },
    };
};

export const searchPageBinder: WebAnalyticsBinder = (webAnalytics) => {
    webAnalytics.pageContext<ActivitiesSearchPageDesktopActivitiesContextIdsV6, ActivitiesSearchPageDesktopActivitiesContextFieldsV6>(
        ActivitiesSearchPageDesktopActivitiesContextManifestV6.ids,
        getSearchPageContextFields(),
    );
};
